/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string, bool, func,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import GraphqlFoodDetailsUI from '../GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';
import { clubComponentType, selectedSkuType } from '../common/types';
import GraphqlWineDisclaimer from '../GraphqlWineDisclaimer/WineDisclaimerContainer';

const styles = (theme) => ({
    contents: {
        textTransform: 'uppercase',
    },
    block: {
        display: 'block',
        width: '95%',
        margin: '0 auto',
    },
    notEligible: {
        color: theme.palette.productTitleColor || '#2f2f2f',
        fontSize: '0.9em',
    },
    serviceLink: {
        '& a': {
            color: theme.palette.productTitleColor || '#2f2f2f',
        },
        fontSize: '14px',
    },
    divider: {
        borderTop: `1px solid ${theme.palette.grey8 || '#ccc'}`,
    },
});

const GraphqlClubDescription = ({
    longDescription,
    classes,
    clubComponents,
    shortDescription,
    productName,
    isPassportEligible,
    setShippingModalOpen,
    selectedSku,
}) => {
    const seed = useUIDSeed();
    const productContents = [...(clubComponents || []).map((component) => (`${component.month || ''}: ${component.name || ''} ${component.productContents}` || ''))];
    return (
        <>
            <DesktopMobile
                breakpoint={960}
                desktop={() => (
                    <div data-testid="club-description-desktop" className={classes.classes}>
                        <p className={classes.contents}>Product Description</p>
                        <ReactMarkdown
                            source={shortDescription}
                            escapeHtml={false}
                        />
                        <ReactMarkdown
                            source={longDescription}
                            escapeHtml={false}
                        />

                        <p>{ReactHtmlParser(productName)}</p>

                        {(clubComponents || []).map((component) => (
                            <p key={seed(component)}>
                                <span>{ReactHtmlParser(component.month) || ''}: {ReactHtmlParser(component.name) || ''}</span>
                                <ReactMarkdown
                                    source={component.productContents || ''}
                                    escapeHtml={false}
                                />
                            </p>
                        ))}
                        {selectedSku?.ageVerifyFlag === 'true' && (
                            <>
                                <div className={classes.divider} />
                                <GraphqlWineDisclaimer />
                            </>
                        )}

                    </div>
                )}
                mobile={() => (
                    <div data-testid="club-description-mobile" className={classes.block}>
                        <div>
                            <GraphqlFoodDetailsUI
                                clubDescription
                                shortDescription={shortDescription}
                                longDescription={longDescription}
                                productContents={productContents}
                                selectedSku={selectedSku}
                            />
                        </div>
                        <div>
                            {!isPassportEligible && (
                                <p className={classes.notEligible}>
                                    <strong>Please Note:</strong> This club is not eligible for CELEBRATIONS PASSPORT&#174;
                                </p>
                            )}
                        </div>
                        <div>
                            <p
                                className={classes.serviceLink}
                            >
                                <span
                                    onClick={() => setShippingModalOpen(true)}
                                    onKeyDown={() => { }}
                                    tabIndex="0"
                                    role="link"
                                >
                                    Shipping and Processing Details
                                </span>
                            </p>
                        </div>
                    </div>
                )}
            />
        </>
    );
};

GraphqlClubDescription.propTypes = {
    classes: object.isRequired,
    longDescription: string.isRequired,
    clubComponents: clubComponentType.isRequired,
    shortDescription: string.isRequired,
    productName: string.isRequired,
    isPassportEligible: bool.isRequired,
    setShippingModalOpen: func,
    selectedSku: selectedSkuType,
};

GraphqlClubDescription.defaultProps = {
    setShippingModalOpen: () => {},
    selectedSku: {},
};

export default (withStyles(styles)(GraphqlClubDescription));
